import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GoVerified, GoVersions } from "react-icons/go";
import { FiUser } from 'react-icons/fi';
import { HiOutlineHome } from 'react-icons/hi2';
import { IsMobileEnv } from '../../configurations/initUrls';
import useAuth from '../../configurations/auth/publicUsers/useAuth';
import QRScanner from '../../configurations/native/QRScanner';
import { MdOutlineFormatListBulleted } from 'react-icons/md';
import { CgUserList } from 'react-icons/cg';
import { VscCoverage } from 'react-icons/vsc';

const FabToggleMobile = () => {
    const { authentication } = useAuth();
    const location = useLocation();

    const items = [
        ...(IsMobileEnv && authentication.isLogin
            ? [
                { to: '/myregister', icon: <CgUserList size={22} />, label: 'My Reg', color: 'text-purple-600' },
                { to: '/myconfirmed', icon: <VscCoverage size={22} />, label: 'My Con', color: 'text-teal-600' },
            ]
            : []),
        { to: '/checkregister', icon: <MdOutlineFormatListBulleted size={22} />, label: 'Register', color: 'text-green-600' },
        { to: '/checkconfirmed', icon: <GoVerified size={22} />, label: 'Confirmed', color: 'text-blue-600' },
    ];

    return (
        <div className="w-full px-1 fixed bottom-4 left-1/2 -translate-x-1/2 z-50">
            <div className="w-full flex items-center justify-between rounded-[32px] bg-white/40 backdrop-blur-md border border-gray-700/20 shadow-xl p-1">
                <QRScanner/>
                {items.map((item) => {
                    const active = location.pathname === item.to;

                    return (
                        <Link key={item.to} to={item.to} className="flex-1 flex justify-center">
                            <div
                                className={`
                                    flex flex-col items-center justify-center
                                    min-w-[64px] px-3 py-2 rounded-[32px]
                                    transition-all duration-300
                                    ${active ? 'bg-black/10 scale-105' : 'hover:bg-black/5'}
                                `}
                            >
                                <div className={active ? item.color : "text-slate-900"}>
                                    {item.icon}
                                </div>
                                <span className={`text-[11px] font-medium mt-1 ${active ? item.color : 'text-slate-800'}`}>
                                    {item.label}
                                </span>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default FabToggleMobile;